<template>
    <task-list :columns="columns"/>
</template>

<script>
    import { compare} from "../utils/request";
    import TaskList from "../biomed-components/TaskList";
    export default {
        name: "TestingList",
        components: {
            TaskList
        },
        data(){
            return {
                columns: [
                    {
                        title: 'Question',
                        dataIndex: 'Question',
                        width: 450,
                        sorter: {
                            compare: compare('Question'),
                        },
                        customFilterDropdown: true,
                        onFilter: (value, record) =>
                            record.Question.toString().toLowerCase().includes(value.toLowerCase()),
                    },
                    {
                        title: 'Task type',
                        dataIndex: 'Task subclass',
                        width: 190,
                        align: 'center',
                        sorter: {
                            compare: compare('Task subclass'),
                        },
                        customFilterDropdown: true,
                        onFilter: (value, record) =>
                            record['Task subclass'].toString().toLowerCase().includes(value.toLowerCase()),
                    },
                    {
                        title: 'Dataset',
                        dataIndex: 'Files',
                        width: 180,
                        // align: 'center'
                    },
                    {
                        title: 'Question type',
                        dataIndex: 'QuestionType',
                        align: 'center',
                        sorter: {
                            compare: compare('QuestionType'),
                        },
                    },
                    {
                        title: 'Self-evoving rounds',
                        dataIndex: 'rounds',
                    }
                ]
            }
        },
    }
</script>
<style>

</style>